module.exports = __webpack_public_path__ + "img/upi_providers.ff321241.png";